import joint from "jointjs";

const Graph = () => {
    const graph = new joint.dia.Graph();
    return graph;
};

export default Graph;